import { createIcon } from './create-icon.js';

/* ────────── Bespoke Perch icons (spec §8) ────────── */

/** A stylized leaf — Perch's take on the bookmark. */
export const IconPerchLeaf = createIcon(
  'PerchLeaf',
  <>
    <path d="M5 19c7 0 14-6 14-14-7 0-14 6-14 14Z" />
    <path d="M5 19c2-5 5-8 10-10" />
  </>,
);

/** Sidebar collapse — a small branching line. */
export const IconBranch = createIcon(
  'Branch',
  <>
    <path d="M5 4v16" />
    <path d="M5 9l5 3" />
    <path d="M5 14l5-3" />
    <path d="M15 7h4" />
    <path d="M15 12h4" />
    <path d="M15 17h4" />
  </>,
);

/** "New" badge — a tiny speckled egg. */
export const IconEgg = createIcon(
  'Egg',
  <>
    <path d="M12 3c4 0 7 5 7 10a7 7 0 0 1-14 0c0-5 3-10 7-10Z" />
    <circle cx="10" cy="11" r="0.6" fill="currentColor" />
    <circle cx="14" cy="14" r="0.6" fill="currentColor" />
    <circle cx="11" cy="16" r="0.6" fill="currentColor" />
  </>,
);

/** Share / export — a stylized feather. */
export const IconFeather = createIcon(
  'Feather',
  <>
    <path d="M20 4c-8 0-12 5-12 12v4h4c7 0 12-4 12-12" />
    <path d="M8 20L20 8" />
    <path d="M14 10h4" />
    <path d="M12 14h4" />
  </>,
);

/** Home — a small nest. */
export const IconNest = createIcon(
  'Nest',
  <>
    <path d="M3 17c2-5 6-8 9-8s7 3 9 8" />
    <path d="M3 17h18" />
    <path d="M6 17l1-2M10 17l1-2M14 17l1-2M18 17l-1-2" />
    <circle cx="12" cy="14" r="1.5" />
  </>,
);

/** Location/region — a leaf with a pin. */
export const IconMapLeaf = createIcon(
  'MapLeaf',
  <>
    <path d="M5 21c6 0 12-6 12-14-6 0-12 4-12 14Z" />
    <circle cx="12" cy="10" r="2" />
    <path d="M12 12v2" />
  </>,
);

/* ────────── General UI icons (Perch-flavored Phosphor) ────────── */

export const IconChevronRight = createIcon('ChevronRight', <path d="M9 6l6 6-6 6" />);

export const IconChevronLeft = createIcon('ChevronLeft', <path d="M15 6l-6 6 6 6" />);

export const IconChevronDown = createIcon('ChevronDown', <path d="M6 9l6 6 6-6" />);

export const IconClose = createIcon(
  'Close',
  <>
    <path d="M6 6l12 12" />
    <path d="M18 6L6 18" />
  </>,
);

export const IconCheck = createIcon('Check', <path d="M5 12l5 5L19 7" />);

export const IconPlus = createIcon(
  'Plus',
  <>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </>,
);

export const IconSend = createIcon(
  'Send',
  <>
    <path d="M3 12L21 4l-4 18-5-8-9-2Z" />
    <path d="M12 14l5-6" />
  </>,
);

export const IconMic = createIcon(
  'Mic',
  <>
    <rect x="9" y="3" width="6" height="12" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0" />
    <path d="M12 18v3" />
  </>,
);

export const IconSearch = createIcon(
  'Search',
  <>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-4-4" />
  </>,
);

export const IconSparkle = createIcon(
  'Sparkle',
  <>
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
    <path d="M12 8l2 2-2 2-2-2 2-2Z" />
  </>,
);

export const IconBook = createIcon(
  'Book',
  <>
    <path d="M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3V4Z" />
    <path d="M5 17a3 3 0 0 1 3-3h11" />
  </>,
);
